import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';

const RequiredExplanation = ({ mt = 2, mb = 2 }) => (
  <Box mt={mt} mb={mb} font="body-asphalt-italic" className="font-in-rem">
    <span className="f-size--1-1">
      {__('* Required fields are marked with an asterisk')}
    </span>
  </Box>
);

RequiredExplanation.propTypes = {
  mt: PropTypes.number,
  mb: PropTypes.number,
};

export default RequiredExplanation;
